const SEASON_DICT = {
  summer: 'Летние',
  winter: 'Зимние',
  'all-season': 'Всесезонные',
};

export function translateSeason(season) {
  return SEASON_DICT[season] ?? season ?? '—';
}
